import { useState } from "react";
import { CheckboxCard } from "shared/components";
import { toast } from "react-toastify";
import { CombinedIncomeSubStep } from "../../../constants";
import { CombinedIncomeLayout } from "../components/Layout";
import { useCombinedIncome } from "../context";
import { getErrorMessage } from "utils/error";

export const IncomeStatusStep = () => {
  const { updateStepMutation } = useCombinedIncome();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSelect = async (hasIncome: boolean) => {
    if (isProcessing) return;

    setIsProcessing(true);
    try {
      await updateStepMutation.mutateAsync({
        lastStep: hasIncome
          ? CombinedIncomeSubStep.SelectIncomeType
          : CombinedIncomeSubStep.NoIncomeReason
      });
    } catch (error) {
      toast.error(getErrorMessage(error) || "Failed to proceed");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <CombinedIncomeLayout title="Is the applicant currently receiving income?">
      <div className="mt-4 flex w-full gap-2">
        <CheckboxCard
          checked={false}
          id="yes"
          label="Yes"
          name="yes"
          wrapperClassName="w-full"
          className="h-[72px] flex items-center justify-center"
          onChange={() => handleSelect(true)}
        />
        <CheckboxCard
          checked={false}
          id="no"
          label="No"
          name="no"
          wrapperClassName="w-full"
          className="h-[72px] flex items-center justify-center"
          onChange={() => handleSelect(false)}
        />
      </div>
    </CombinedIncomeLayout>
  );
};
